import request from '../../config/axiosConfig';
import { 
  GET_LIST_SURVEYS, 
  CREATE_SURVEY, 
  UPDATE_SURVEY, 
  DELETE_SURVEY,
  GET_SURVEY_INFO 
} from '../../constants/apiEndPoint';

const surveyService = {
  getList: async (params) => {
    const { data } = await request({ url: GET_LIST_SURVEYS, method: 'POST', data: params });
    return data;
  },

  getDetail: async (id) => {
    const { data } = await request({ url: GET_SURVEY_INFO, method: 'POST', data: { id } });
    return data;
  },

  create: async (dataBody) => {
    const { data } = await request({ url: CREATE_SURVEY, method: 'POST', data: dataBody });
    return data;
  },

  update: async (id, dataBody) => {
    const { data } = await request({ url: UPDATE_SURVEY, method: 'POST', data: { ...dataBody, id } });
    return data;
  },

  delete: async (id) => {
    const { data } = await request({ url: DELETE_SURVEY, method: 'POST', data: { id } });
    return data;
  },
};

export default surveyService;
